import { useEffect, useRef, useState } from "react";

export type InGameDialogRequest =
  | { kind: "alert"; title: string; message: string }
  | { kind: "confirm"; title: string; message: string; confirmLabel?: string }
  | { kind: "prompt"; title: string; message?: string; initialValue?: string; confirmLabel?: string };

type PendingDialog = InGameDialogRequest & { resolve: (value: string | boolean | undefined) => void };
export const IN_GAME_DIALOG_EVENT = "tbltop:in-game-dialog";

export function InGameDialogHost() {
  const [current, setCurrent] = useState<PendingDialog>();
  const queued = useRef<PendingDialog[]>([]);
  const inputRef = useRef<HTMLInputElement>(null);
  const showNext = () => setCurrent(queued.current.shift());

  useEffect(() => {
    const onRequest = (event: Event) => {
      const detail = (event as CustomEvent<PendingDialog>).detail;
      queued.current.push(detail);
      setCurrent((active) => active ?? queued.current.shift());
    };
    window.addEventListener(IN_GAME_DIALOG_EVENT, onRequest);
    return () => window.removeEventListener(IN_GAME_DIALOG_EVENT, onRequest);
  }, []);
  useEffect(() => { if (current?.kind === "prompt") window.setTimeout(() => inputRef.current?.focus(), 0); }, [current]);
  if (!current) return null;
  const close = (value: string | boolean | undefined) => { current.resolve(value); setCurrent(undefined); window.setTimeout(showNext, 0); };
  const destructive = current.kind === "confirm" && /delete|remove|reset|clear|replace/i.test(current.confirmLabel ?? current.title);
  return <div className="modal-backdrop in-game-dialog-backdrop" role="presentation" onMouseDown={(event) => { if (event.target === event.currentTarget && current.kind !== "alert") close(current.kind === "confirm" ? false : undefined); }}>
    <section className="modal in-game-dialog" role="dialog" aria-modal="true" aria-labelledby="in-game-dialog-title">
      <header><div><span className="eyebrow">TBLTOP</span><h2 id="in-game-dialog-title">{current.title}</h2></div></header>
      <p>{current.message}</p>
      {current.kind === "prompt" ? <form onSubmit={(event) => { event.preventDefault(); close(inputRef.current?.value ?? ""); }}><input ref={inputRef} defaultValue={current.initialValue ?? ""} aria-label={current.title} /><div className="modal-actions"><button type="button" className="button subtle" onClick={() => close(undefined)}>Cancel</button><button className="button primary" type="submit">{current.confirmLabel ?? "Save"}</button></div></form> : <div className="modal-actions">{current.kind === "confirm" ? <button className="button subtle" onClick={() => close(false)}>Cancel</button> : null}<button autoFocus className={`button ${destructive ? "danger" : "primary"}`} onClick={() => close(current.kind === "confirm" ? true : undefined)}>{current.kind === "confirm" ? current.confirmLabel ?? "Continue" : "OK"}</button></div>}
    </section>
  </div>;
}
